module.exports = __webpack_public_path__ + "static/media/ContasPagRec6.3d590f2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/RelContasPagRec/ContasPagRec6.png
// module id = 2016
// module chunks = 0